import PrettyCheck from 'pretty-checkbox-vue/check';
import PrettyRadio from 'pretty-checkbox-vue/radio';
import inView from 'in-view';
import Spinner from "../components/Spinner";

const app = new Vue({
    el: '#search-page',
    components: {
        PrettyCheck,
        PrettyRadio,
        Spinner
    },
    data() {
        return {
            results: window.gigulous.searchResults,
            query: window.gigulous.searchQuery,
            loading: false,
            sort: 'latest',
            minQueryLength: 3,
            filter: {
                type: window.gigulous.searchType,
                visible: false
            },
            page: 1,
            limit: 12,
            stopInternalSearch: false,
            stopLoadMore: false
        }
    },
    methods: {
        updateReviewsOrder(){
            this.$refs.reviews.get(this.reviewsOrderBy);
        },
        updateImagesOrder(){
            this.$refs.images.get(this.imagesOrderBy);
        },
        async search(){
            if((this.query.length < this.minQueryLength) && (this.filter.type === 'all')){
                this.active = false;
                this.loading = false;
                return;
            }

            this.active = true;
            this.loading = true;
            this.results = await this.apiSearch(this.query);
            if(this.filter.type === 'artists') {
                if (!this.results.length) {
                    this.results = await this.thirdPartySearch(this.query);
                }
            }
            this.loading = false;
        },
        apiSearch(query)
        {
            return this.$http.get(window.baseUrl + "/api/search/"+query, {
                params: {
                    type: this.filter.type,
                    page: this.page,
                    limit: this.limit
                }
            })
                .then(response => {
                    if(response.data.success){
                        if(this.filter.type === 'all'){
                            if(response.data.current_page === response.data.last_page){
                                this.stopInternalSearch = true;
                            }
                            return response.data.data;
                        }
                        if(response.data.data.current_page === response.data.data.last_page){
                            this.stopInternalSearch = true;
                        }
                        return response.data.data.data;
                    }
                    return [];
                });

        },
        thirdPartySearch(query)
        {
            return this.$http.get(window.baseUrl + "/api/search/thirdparty/artists/"+query, {
                params: {
                    type: this.filter.type
                }
            })
                .then(response => {
                    if(response.data.success){
                        if(this.filter.type === 'all'){
                            return response.data.data;
                        }
                        return response.data.data.data;
                    }
                    return [];
                });

        },
        showFilters()
        {
            this.filter.visible = true;
        },
        async loadMore()
        {
            if(this.stopLoadMore){
                return;
            }
            if(!this.results.length){
                return;
            }
            this.page++;
            this.active = true;
            this.loading = true;
            let newResults;
            if(!this.stopInternalSearch){
                newResults = await this.apiSearch(this.query);
            }
            if(this.stopInternalSearch || !newResults.length){
                if(this.filter.type === 'artists'){
                    newResults = await this.thirdPartySearch(this.query);
                }
            }
            if(typeof newResults !== 'undefined' && newResults.length){
                this.results = this.results.concat(newResults);
            }
            else{
                this.stopLoadMore = true;
            }
            this.loading = false;
        },

        loadMoreOnScroll()
        {
            inView('.footer')
                .on('enter', () => {
                    this.loadMore();
                });
        }
    },
    mounted() {
        this.loadMoreOnScroll();
    }
});
